import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const PreRecord = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('shoot_item5'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div style={{ width: '100%' }}>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 15, lineHeight: '22px' }}>{t('pre_record_content')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}pre_record.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
        </div>
    </div>
}

export default PreRecord